import { render } from "./PostVideoStatsPage.vue?vue&type=template&id=9899cf60"
import script from "./PostVideoStatsPage.vue?vue&type=script&lang=js"
export * from "./PostVideoStatsPage.vue?vue&type=script&lang=js"
script.render = render

export default script